<template>
	<Page>
		<template #content>
			<SafeAreaTop theme="white-invert" @close="close" />
			<div class="image-container">
				<img src="@/assets/post/cookies.png" alt="" />
			</div>
			<div class="container">
				<div class="title">Emotional eating: <br />Take control</div>
				<div class="subtitle">The next time you feel emotionally hungry, you’ll be ready</div>
				<div class="points">
					<div class="points-item" v-for="item in points" :key="item.id">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.2496 5.72738C12.5409 5.25814 12.3966 4.64163 11.9274 4.35038C11.4581 4.05912 10.8416 4.20341 10.5504 4.67266L7.59069 9.44102L5.68045 7.66722C5.27574 7.29142 4.64301 7.31486 4.26721 7.71957C3.8914 8.12428 3.91484 8.75701 4.31955 9.13281L6.22979 10.9066C7.15194 11.7629 8.62633 11.5649 9.28997 10.4957L12.2496 5.72738Z"
								fill="#7D8BF7"
							/>
						</svg>

						<div class="points-text">{{ item.text }}</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:footer>
			<div class="container">
				<div class="product-info">
					<span>One-time payment of {{ product?.localizedPriceString }} </span>
					<i>•</i>
					<span>Lifetime access</span>
				</div>
				<PButton @click.prevent="handleSubmit" label="" :loading="isLoading" cls="btn btn-primary btn-block">
					Сontinue
				</PButton>
				<ProductTerms :terms="`Check <b>${email}</b> for access to your 14-day course`" />
			</div>
		</template>
	</Page>
</template>

<script setup>
import Page from '@/components/Page'
import SafeAreaTop from '@/components/SafeAreaTop'
import ProductTerms from '@/components/ProductTerms'
import { computed, ref } from '@vue/reactivity'
import PButton from '@/components/Button'
import useApi from '@/composition/api'
import { inject, onMounted } from '@vue/runtime-core'
import { useStore } from 'vuex'
import useEnv from '@/composition/env.js'

const env = useEnv()
const api = useApi()
const amplitude = inject('amplitude')
const appboy = inject('appboy')
const store = useStore()
const userId = computed(() => store.state.user.user_id)
const email = computed(() => store.state.user.email)
const product = computed(() => store.getters['products/getProductById']('ios_emotional_eating_course') ?? {})

const isLoading = computed(() => store.state.isLoading)

const points = computed(() => {
	return [
		{
			id: 1,
			text: 'Led by expert psychologist and nutritionists'
		},
		{
			id: 2,
			text: 'Learn what causes emotional eating'
		},
		{
			id: 3,
			text: 'Create an emotional eating emergency kit'
		}
	]
})

function handleSubmit() {
	purchase(product.value)
}

function purchase(product) {
	api.purchase({
		productId: product.id,
		onFinish: async () => {
			await appboy.canvas(env('BRAZE_EMOTIONAL_COURSE_CANVAS_ID'), userId.value)

			close('Subscribe', {
				action: 'purchase',
				product_id: product?.id,
				price: product?.price,
				currency: product?.currencyCode
			})
		},
		onError: () => {},
		onCancel: () => {},
		closeOnSuccess: false
	})
}

function close(action = 'close', product = {}) {
	amplitude.logEvent(store.getters['getAmplitudeEventName']('AddProductPaywallDone'), {
		action,
		product_type: 'emotional_eating_course',
		...product
	})

	api.close()
}

onMounted(() => {
	const { currencyCode: currency, price, id } = product.value
	amplitude.logEvent(store.getters['getAmplitudeEventName']('AddProductPaywallShow'), {
		product_ids: [id],
		product_type: 'emotional_eating_course',
		prices: [price],
		currency
	})
})
</script>

<style scoped lang="scss">
.image-container {
	max-width: 500px;
	margin-left: auto;
	margin-right: auto;
}

img {
	width: 100%;
	max-width: 100%;
	max-height: none;
	height: auto;
}

.title {
	font-weight: 900;
	text-align: center;
	font-size: 2.2rem;
	line-height: 1.15;
	padding-top: 2vh;
}

.subtitle {
	margin-top: 0.9rem;
	text-align: center;
	font-weight: 500;
	max-width: 80%;
	margin-left: auto;
	margin-right: auto;
	line-height: 1.44;
	font-size: 1.2rem;
}

.points {
	margin: 1.5rem 0;
	font-size: 1.1rem;
}

.points-item {
	display: flex;
	align-items: center;
	letter-spacing: -0.32px;
	color: #323653;

	&:not(:last-child) {
		margin-bottom: 1rem;
	}

	svg {
		margin-right: 0.8rem;
		display: block;
	}
}

.product-info {
	margin-bottom: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;

	i {
		margin: 0 10px;
	}
}

.terms {
	margin-top: 1rem;
}
</style>
